import React from 'react'

import { GrowthBook, GrowthBookProvider } from '@growthbook/growthbook-react'
import { growthbookTrackingCallback } from '@src/Infrastructure/Growthbook/utils'

const apiHost = process.env.GATSBY_GROWTHBOOK_API_HOST
const clientKey = process.env.GATSBY_GROWTHBOOK_CLIENT_KEY

let growthbook: GrowthBook | null = null

if (apiHost && clientKey) {
    growthbook = new GrowthBook({
        apiHost,
        clientKey,
        subscribeToChanges: true,
        trackingCallback: growthbookTrackingCallback,
    })

    // Preload features once per runtime
    growthbook.loadFeatures()
}

export const wrapRootElement = ({ element }: { element: React.ReactNode }): React.ReactNode => {
    if (!growthbook) return element

    return <GrowthBookProvider growthbook={growthbook}>{element}</GrowthBookProvider>
}
